import useFetch from 'utils/hooks/useFetch'
import { ApiGetPaymentReceived, ApiUpdatePaymentReceived } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'
import moment from 'moment'

export function PaymentReceivedService() {
    const { showFail } = useModal()

    const { fetch: getTransactionList } = useFetch(ApiGetPaymentReceived)
    const { fetch: updatePaymentReceived } = useFetch(ApiUpdatePaymentReceived)
 
    const fetchPaymentReceivedTransactionList = async (date, groupBy, edcId, year, month) => {
        let dateFrom = date
        let dateTo = date

        if (groupBy === "edc"){
            dateFrom = new Date(year, month - 1, 1)
            dateTo = new Date(year, month, 0)
        }   

        const res = await getTransactionList({
            data: {
                dateFrom: moment(dateFrom).format('YYYY-MM-DD'),
                dateTo: moment(dateTo).format('YYYY-MM-DD'),
                groupBy: groupBy,
                edcId: edcId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdatePaymentReceived = async (edcId, transactionDate, paymentReceived) => {
        const res = await updatePaymentReceived({
            data: {
                edcId,
                transactionDate,
                paymentReceived
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    
    return {
        fetchPaymentReceivedTransactionList,
        fetchUpdatePaymentReceived
    }
}